import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ViewProps } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import HomeIcon from '@/assets/icons/tab/home';
import { lobbyId, useLobbySectionSelection } from '@/feature/lobby/hooks/use-lobby-section-selection';
import { PickemLobbyTabNavigationProp } from '@/navigation/pickem/types';
import { designSystem } from '@/styles/styles';

import { LaunchpadTile } from './LaunchpadTile';

/**
 * A tile component that provides navigation to the main lobby screen
 * @param onLayout - Layout event handler for the tile - function from the parent LeftSideTabBar
 * @param updateTab - Callback function to update the currently active tab in parent navigation
 */
export const PickemLobbyLaunchpadTile = ({
    onLayout,
    updateTab,
}: {
    onLayout: ViewProps['onLayout'];
    updateTab: () => void;
}) => {
    const { selectedTile, actions } = useLobbySectionSelection();
    const navigation = useNavigation<PickemLobbyTabNavigationProp>();

    const isSelected = selectedTile === lobbyId;
    const { t } = useTranslation('common');

    const onPressLobby = useCallback(() => {
        updateTab();
        navigation.setParams({
            league: lobbyId,
        });
        actions.setSelectedTile(lobbyId);
    }, [navigation, updateTab, actions]);

    return (
        <LaunchpadTile
            onLayout={onLayout}
            icon={<HomeIcon fill={designSystem.colors.white} width={22} height={22} />}
            label={t('lobby')}
            onPress={onPressLobby}
            selected={isSelected}
        />
    );
};
